/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "Aceitar todos",
      "Usamos os cookies para melhorar o funcionamento do nosso site. Isso inclui cookies analíticos e cookies de publicidade. Para mais informações, confira nossa <a p0>Política de Cookies</a>",
      "Gerenciar opções",
      "Confirme que você concorda com os cookies",
      "Política de Cookies",
      "Gerenciar Cookies",
      "(abre em nova janela)",
      "Migalhas",
      "Página inicial",
      "Rodapé",
      "© {{current_year}} Bumble Todos os direitos reservados",
      "Criar perfil",
      "Baixar o aplicativo",
      "Ajuda",
      "Imprensa",
      "Privacidade",
      "Termos",
      "Página inicial do {{partner}}",
      "Orgulhosamente parte do Bumble Inc",
      "Sobre",
      "Blog",
      "Vagas",
      "Geral",
      "Facebook",
      "Siga",
      "Instagram",
      "Twitter",
      "Se você alguma vez se sentir desconfortável, se deparar com um comportamento prejudicial ou simplesmente precisar de um conselho, estamos aqui. Explore nossa variedade de guias para encontrar dicas práticas e suporte.",
      "Página do Safety Centre do {{partner}}",
      "Segurança em primeiro lugar.",
      "Boas-vindas ao Safety Centre, por favor, veja o vídeo",
      "Mais guias",
      "Fechar menu",
      "Guias",
      "Linha de ajuda anterior",
      "Ver mais linhas de ajuda",
      "Linhas de ajuda",
      "Principal",
      "Menu",
      "Abrir menu",
      "Ferramentas",
      "Atualizações",
      "Voltar",
      "Atualize seu navegador ou volte para nossa página principal.",
      "Página não encontrada.",
      "Você ainda precisa de ajuda?",
      "Tente buscar uma expressão diferente ou <a href=\"{{feedback_url}}\" class=\"link\">contate-nos</a>",
      "Verifique a ortografia",
      "Use termos genéricos e expanda os resultados",
      "Tente uma pesquisa semelhante, mas diferente",
      "Não pare agora. Aqui estão algumas dicas:",
      "Você também pode achar isso útil:",
      "Não conseguimos encontrar resultados que correspondam à sua pesquisa.",
      "Resultados da busca",
      "Resultados da busca para {{search_query}}",
      "Limpar busca",
      "Como podemos ajudar?",
      "Pesquisar",
      "No Bumble não toleramos más vibrações, linguagem ofensiva ou abuso. Levamos muito a sério e investigamos todas as denúncias de comportamento prejudicial.",
      "Cuidamos de você e de nossa comunidade. Portanto, se alguém te deixar desconfortável ou inseguro, não hesite em denunciar e nós tomaremos as medidas necessárias.",
      "Conteúdo sexual não solicitado ou não consensual não é aceitável. Se alguém enviar a você uma foto explícita, nós a desfocaremos primeiro.",
      "Um fraudador é uma pessoa que usa um perfil falso para fingir ser outra pessoa. Eles fazem isso para enganar as pessoas online. Se precisar de ajuda, nós lhe daremos apoio.",
      "O assédio pode ser sexual ou não sexual. Se alguém assediar você no Bumble ou na vida real, não hesite em nos contatar.",
      "Encontro a vista? Legal! Ajudamos você com sua segurança no Bumble, e na vida real. Então, se você já quer se encontrar, vamos nos preparar.",
      "Com Covid, sair não era uma opção. Marcar um encontro pode ser arriscado, então veja o que você deve ter em mente antes de sair do Bumble para a vida real.",
      "O primeiro encontro deve ser divertido. Pode ser estranho no início, mas nunca inseguro. Concentre-se em se divertir e ficar seguro com essas dicas.",
      "Sabemos que começar (ou retomar após um intervalo) pode ser opressor, mas estamos aqui para ajudar. Aqui estão algumas coisas que você pode fazer para se adaptar.",
      "É fácil se sentir sobrecarregado ou esgotado durante os encontros. Se você cansou de procurar por relacionamentos, temos certeza que você não é único.",
      "Quando alguém trai sua confiança, pode ser difícil reconquistá-la. Sabemos como isso é estressante, por isso estamos aqui para ajudar.",
      "Se você está lidando com sentimentos de rejeição, temos uma grande lista de coisas das quais você deve sempre se lembrar.",
      "O Bumble é um local de liberdade, segurança e diversão para cada todos de nossa comunidade. Aqui estão nossas dicas para segurança nos encontros.",
      "A verificação permite que você mostre a futuras conexões que você é uma pessoa real. Descubra como ser verificado aqui. Isso levará apenas alguns minutos.",
      "Golpes de namoro existem, então fique atento e observe o que está sendo compartilhado. Aqui vão algumas dicas para se proteger de possíveis golpes.",
      "Antes de qualquer ato íntimo ou sexual com outra pessoa, é sempre necessário o consentimento claro e voluntário de ambas as partes para a prática dessa atividade.",
      "Enviar uma primeira mensagem para alguém pode ser complicado. Temos muitas dicas que você pode usar para começar com o pé direito.",
      "Nosso Safety Centre para encontros online foi desenvolvido para aumentar a sua segurança e controle no Bumble. Veja nossos guias, ferramentas e linhas de ajuda.",
      "Comportamento nocivo | Safety Centre - Bumble",
      "O que acontece quando eu denuncio | Safety Centre - Bumble",
      "Comportamento nocivo: Recebendo uma foto explícita | Safety Centre - Bumble",
      "Comportamento nocivo: Perfis falsos - Fraudes | Safety Centre - Bumble",
      "Comportamento nocivo: Estou sofrendo assédio | Safety Centre - Bumble",
      "Encontros na vida real | Safety Centre - Bumble",
      "Encontros na vida real: Encontros durante o Covid | Safety Centre - Bumble",
      "Encontros na vida real: Segurança em um encontro | Safety Centre - Bumble",
      "Bem-estar mental | Safety Centre - Bumble",
      "Bem-estar mental: O que fazer ao cansar da procura por relacionamentos e como superar | Safety Centre - Bumble",
      "Bem-estar mental: Quando alguém perde minha confiança | Safety Centre - Bumble",
      "Bem-estar mental: Como lidar com a falta de conexões ou respostas | Safety Centre - Bumble",
      "Dicas de segurança para segurança nos encontros | Safety Centre - Bumble",
      "Dicas de segurança: Como a verificação funciona | Safety Centre - Bumble",
      "Dicas de segurança: Como se manter alerta e protegido contra golpes | Safety Centre - Bumble",
      "Dicas de segurança: Pedir e dar consentimento | Safety Centre - Bumble",
      "Dicas de segurança: Iniciando uma conversa da maneira certa | Safety Centre - Bumble",
      "Safety Centre para Relacionamentos Online | Bumble",
      "Baixe no App Store",
      "Baixe no Google Play",
      "Fechar seção",
      "fechar",
      "Mais opções",
      "Projetamos essas ferramentas para fornecer total segurança e controle durante toda a sua jornada por aqui. Descubra como gerenciar sua experiência no Bumble.",
      "Para mais dicas e informações de especialistas sobre tendências de encontros, sexualidade, vida de solteiro e muito mais, confira nosso blog.",
      "Nosso Manual de segurança",
      "Seleção de idioma"
],

    // These are the common words found in the lexemes of the app
    common: {
      "day": {
            "plural": [
                  "dias"
            ],
            "singular": [
                  "dia"
            ]
      },
      "hour": {
            "plural": [
                  "horas"
            ],
            "singular": [
                  "hora"
            ]
      },
      "minute": {
            "plural": [
                  "minutos"
            ],
            "singular": [
                  "minuto"
            ]
      },
      "month": {
            "plural": [
                  "meses"
            ],
            "singular": [
                  "mês"
            ]
      },
      "second": {
            "plural": [
                  "segundos"
            ],
            "singular": [
                  "segundo"
            ]
      },
      "year": {
            "plural": [
                  "anos"
            ],
            "singular": [
                  "ano"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
